import React from 'react';
import styled from 'styled-components';
import { FaBolt, FaClock, FaShieldAlt, FaMagic } from 'react-icons/fa';
import { useLanguage } from '../i18n/LanguageContext';

const FeaturesSection = styled.section`
  padding: 8rem 8rem;
  background: linear-gradient(180deg, #fafafa 0%, #f5f5f5 100%);
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(0,0,0,0.1), transparent);
  }
  
  @media (max-width: 1024px) {
    padding: 6rem 2rem;
  }
`;

const FeaturesContainer = styled.div`
  max-width: 1600px;
  margin: 0 auto;
`;

const FeaturesTitle = styled.h2`
  text-align: center;
  margin-bottom: 3rem;
  font-size: 2.5rem;
  color: #3182CE;
`;

const FeaturesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;
  padding: 0 1rem;
  
  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

const FeatureCard = styled.div`
  padding: 2.5rem;
  background: white;
  border-radius: 16px;
  box-shadow: 0 8px 30px rgba(0,0,0,0.06);
  transition: all 0.4s ease;
  text-align: center;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #0052CC, #00B8D9);
    opacity: 0;
    transition: opacity 0.3s ease;
  }
  
  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 12px 40px rgba(0,0,0,0.1);
    
    &::before {
      opacity: 1;
    }
  }

  svg {
    font-size: 2.8rem;
    background: linear-gradient(135deg, #0052CC 0%, #00B8D9 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin-bottom: 1.8rem;
  }

  h3 {
    font-size: 1.5rem;
    color: #333;
    margin-bottom: 1rem;
  }

  p {
    color: #666;
    line-height: 1.6;
  }
`;

const Features: React.FC = () => {
  const { t } = useLanguage();
  const icons = [FaBolt, FaClock, FaShieldAlt, FaMagic];
  
  // 获取features项目，确保设置returnObjects选项为true
  const featureItems = t('features.items', { returnObjects: true }) as Array<{ title: string; description: string }>;

  return (
    <FeaturesSection id="features">
      <FeaturesContainer>
        <FeaturesTitle>{t('features.title')}</FeaturesTitle>
        <FeaturesGrid>
          {featureItems.map((feature: any, index: number) => {
            const Icon = icons[index];
            return (
              <FeatureCard key={index}>
                <Icon />
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </FeatureCard>
            );
          })}
        </FeaturesGrid>
      </FeaturesContainer>
    </FeaturesSection>
  );
};

export default Features; 